import { LOCALES } from 'i18n/locales';

export const routeErrorsIntl = {
    [LOCALES.ENGLISH]: {
        'errorPage.title': 'Error',
        'errorPage.serviceDesk': 'Servicedesk',
        'errorPage.redirect': 'Redirect',
        'errorPage.400': `
            <h1>400 - Bad Request</h1>
            <message></message>
            <p>If you typed the web address, check it is correct.</p>
            <p>Contact the <serviceDesk>NUAR service desk</serviceDesk> if you have any questions.</p>
        `,
        'errorPage.401': `
            <h1>401 - Unauthorised</h1>
            <message></message>
            <p>You are not authorised to view this page.</p>
            <p>If you are not signed in, click <login>here</login>.</p>
            <p>For further help, contact the <serviceDesk>NUAR service desk</serviceDesk>.</p>
        `,
        'errorPage.403': `
            <h1>403 - Forbidden</h1>
            <message></message>
            <p>You do not have permission to view this page.</p>          
            <p>For further help, contact the <serviceDesk>NUAR service desk</serviceDesk>.</p>
        `,
        'errorPage.404': `
            <h1>404 - Page not found</h1>
            <p>If you typed the web address, check it is correct.</p>
            <message></message>
            <p>For further help, contact the <serviceDesk>NUAR service desk</serviceDesk>.</p>
        `,
        'errorPage.404_user_profile_not_found': `
            <h1>404 - Page not found</h1>
            <p>There is a problem with your account.</p>
            <message></message>
            <p>Please contact the <serviceDesk>NUAR service desk</serviceDesk>.</p>
        `,
        'errorPage.408': `
            <h1>408 - Request Timeout</h1> 
            <message></message>          
            <p>For further help, contact the <serviceDesk>NUAR service desk</serviceDesk>.</p>
        `,
        'errorPage.429': `
            <h1>429 - Too Many Requests</h1>
            <message></message>
            <p>Try again later</p>
            <p>For further help, contact the <serviceDesk>NUAR service desk</serviceDesk>.</p>
        `,
        'errorPage.500': `
            <h1>500 - Sorry, there is a problem with the <service>Service</service></h1>
            <message></message>
            <p>Try again later</p>
            <p>Contact the <serviceDesk>NUAR service desk</serviceDesk> if you have any questions.</p>
        `,
        'errorPage.503': `
            <h1>503 - Service Unavailable</h1>
            <message></message>
            <p>Sorry, there is a problem with the <service>Service</service>.</p>
            <p>This error can occur when the network request is blocked client side (error F12).</p>
            <p>For further help, contact the <serviceDesk>NUAR service desk</serviceDesk>.</p>
        `,
        'errorPage.furtherHelp': 'For further help, contact the <serviceDesk>NUAR Service Desk</serviceDesk>',
        'errorPage.serviceDeskFallback.email': 'NUAR service desk email address - <serviceEmail></serviceEmail>',
        'errorPage.serviceDeskFallback.phone': 'NUAR service desk telephone - <servicePhone></servicePhone>'
    },
    [LOCALES.WELSH]: { // TODO: refactor to avoid HTML in translation strings
        'errorPage.title': 'Gwall',
        'errorPage.serviceDesk': 'Desg gymorth',
        'errorPage.redirect': 'Ailgyfeirio',
        'errorPage.400': `
            <h1>400 - Cais Gwael</h1>
            <message></message>
            <p>Os teipioch y cyfeiriad gwe, gwiriwch ei fod yn gywir.</p>
            <p>Cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk> os oes gennych unrhyw gwestiynau.</p>
        `,
        'errorPage.401': `
            <h1>401 - Heb ei awdurdodi</h1>
            <message></message>
            <p>Nid ydych wedi'ch awdurdodi i weld y dudalen hon.</p>
            <p>Os nad ydych wedi mewngofnodi, cliciwch <login>yma</login>.</p>
            <p>Am ragor o gymorth, cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk>.</p>
        `,
        'errorPage.403': `
            <h1>403 - Gwaharddwyd</h1>
            <message></message>
            <p>Nid oes gennych ganiatd i weld y dudalen hon.</p>
            <p>Am ragor o gymorth, cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk>.</p>
        `,
        'errorPage.404': `
            <h1>404 - Tudalen heb ei chanfod</h1>
            <p>Os teipioch y cyfeiriad gwe, gwiriwch ei fod yn gywir.</p>
            <message></message>
            <p>Am ragor o gymorth, cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk>.</p>
        `,
        'errorPage.404_user_profile_not_found': `
            <h1>404 - Tudalen heb ei chanfod</h1>
            <p>[There is a problem with your account.]</p>
            <message></message>
            <p>[Please contact the <serviceDesk>NUAR service desk</serviceDesk>.]</p>
        `,
        'errorPage.408': `
            <h1>408 - Terfyn amser i'r Cais</h1>
            <message></message>
            <p>Am ragor o gymorth, cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk>.</p>
        `,
        'errorPage.429': `
            <h1>429 - [Too Many Requests]</h1>
            <message></message>
            <p>Ceisiwch eto yn nes ymlaen</p>
            <p>Am ragor o gymorth, cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk>.</p>
        `,
        'errorPage.500': `
            <h1>500 - Mae'n ddrwg gennym, mae problem gyda'r gwasanaeth <service>Gwasanaeth</service></h1>
            <message></message>
            <p>Ceisiwch eto yn nes ymlaen</p>
            <p>Cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk> os oes gennych unrhyw gwestiynau.</p>
        `,
        'errorPage.503': `
            <h1>503 - [Service Unavailable]</h1>
            <message></message>
            <p>Mae'n ddrwg gennym, mae problem gyda'r gwasanaeth <service>Gwasanaeth</service>.</p>
            <p>[This error can occur when the network request is blocked client side (error F12)].</p>
            <p>Am ragor o gymorth, cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk>.</p>
        `,
        'errorPage.furtherHelp': 'Am ragor o gymorth, cysylltwch â <serviceDesk>desg wasanaeth NUAR</serviceDesk>.',
        'errorPage.serviceDeskFallback.email': 'Cyfeiriad E-bost Desg Wasanaeth NUAR - <serviceEmail></serviceEmail>',
        'errorPage.serviceDeskFallback.phone': 'Ffôn Desg Wasanaeth NUAR - <servicePhone></servicePhone>'
    }
};
